module.exports = __webpack_public_path__ + "img/owl-orange-left.3ebe77e3.png";